export const REQUIRED_MESSAGES = {
    text: 'Заполните поле',
    number: 'Укажите значение',
    money: 'Укажите сумму',
    select: 'Выберите значение',
    multiple: 'Выберите хотя бы одно значение',
    date: 'Укажите дату',
    dateTime: 'Укажите дату и время',
    time: 'Укажите время',
    year: 'Укажите год',
    yesNo: 'Выберите «Да» или «Нет»',
    choice: 'Выберите вариант',
    checkbox: 'Установите флажок',
    file: 'Прикрепите файл',
    rating: 'Выберите оценку',
} as const;

export type RequiredControlType = keyof typeof REQUIRED_MESSAGES;

/** Пустое переопределение из конфигурации оставляет стандартный текст. */
export const getRequiredMessage = (type: RequiredControlType, message?: string | null): string =>
    message?.trim() || REQUIRED_MESSAGES[type];
